import StopIconCell from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['stop_type'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { stop_type: stopType } = props.selectors.getJourneyStopFields(
      state,
      props.journeyId,
      props.stopId,
      fields
    );
    return {
      stopType,
    };
  })
);

export default enhance(StopIconCell);
